var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-report-desc"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function click($event) {
        return _vm.closeReport();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('liveroom.personalCard.reasons')))]), _vm._v(" "), _c('div', {
    staticClass: "reasons-wrap"
  }, [_c('div', {
    staticClass: "reasons"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.textReason,
      expression: "textReason"
    }],
    attrs: {
      "placeholder": _vm.$t('liveroom.personalCard.reasonDesc')
    },
    domProps: {
      "value": _vm.textReason
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.textReason = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "count",
    class: {
      num: _vm.textReason.length > 100
    }
  }, [_vm._v(_vm._s(_vm.textReason.length) + "/100")])])]), _vm._v(" "), _c('card-tip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.tipInfo,
      expression: "tipInfo"
    }],
    attrs: {
      "tipInfo": _vm.tipInfo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "send",
    class: {
      'gray': _vm.textReason.length <= 0
    },
    on: {
      "click": function click($event) {
        return _vm.sendReport();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.personalCard.send')))])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };